import { render, staticRenderFns } from "./replyList.vue?vue&type=template&id=73c2db58&scoped=true"
import script from "./replyList.vue?vue&type=script&lang=js"
export * from "./replyList.vue?vue&type=script&lang=js"
import style0 from "./replyList.vue?vue&type=style&index=0&id=73c2db58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2db58",
  null
  
)

export default component.exports